import { useState } from "react";
import { FormControl } from "react-bootstrap";
import { AutoCompleteSuggestions } from "./AutoCompleteSuggestions";
import "./autocomplete-dropdown.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

export const AutoComplete = ({ keyword, setKeyword, suggestions, onSelectSuggestion, placeholder, disabled, suffix = false }) => {
  const [isAutoCompleteVisible, setAutoCompleteVisible] = useState(false);
  const onInputChange = (e) => {
    setKeyword(e.target.value);
    setAutoCompleteVisible(true);
  };

  const onKeyDown = (e) => {
    if (e.key !== "Enter") return null;
    setAutoCompleteVisible(false);
    const index = suggestions.findIndex((sug) => sug.toLowerCase().includes(keyword.toLowerCase()));
    const suggestion = { value: suggestions[index] || keyword };
    onSelectSuggestion(suggestion)();
  };

  return (
    <section className="position-relative">
      <FormControl
        size="sm"
        value={keyword}
        placeholder={placeholder}
        onChange={onInputChange}
        onBlur={() => setAutoCompleteVisible(false)}
        onFocus={() => setAutoCompleteVisible(true)}
        disabled={disabled}
        onKeyDown={onKeyDown}
      />

      {suffix && <FontAwesomeIcon
        icon={faChevronDown}
        className="position-absolute"
        style={{
          right: "4px",
          pointerEvents: "none",
          color: "#495057",
          fontSize: "0.6rem",
          top: "0.6rem"
        }}
      />}

      {isAutoCompleteVisible && (
        <AutoCompleteSuggestions suggestions={suggestions} onSelectSuggestion={onSelectSuggestion} />
      )}
    </section>
  );
};
